import {
  Avatar,
  Box,
  Chip,
  Grid,
  Stack,
  Tooltip,
  Typography,
} from '@mui/material';
import MUIDataTable from 'mui-datatables';
import * as React from 'react';
import * as Redux from 'react-redux';
import styled from 'styled-components';
import * as CONST from '../../../../constants/FieldsConst';
import { textLabels } from '../../../../helpers';
import { useNotification } from '../../../../helpers/Notification';
import { LoadingWidget } from '../../../../widgets';
import ActionsListWidget from '../../../../widgets/ActionsList';
import DeleteModalComponent from '../../../../widgets/modals/DeleteModal';
import { NameComponent } from '../../../usuario/usuarios/components/ListadoUsuarios';
import {
  allVistasAction,
  deleteVistasAction,
  setActivoVistasAction,
} from '../VistasAction';

export const Links = styled.a`
  cursor: pointer;
  color: black;
  margin: 0px 0px;
  text-decoration: none;

  &:hover {
    color: blue;
  }
`;

const ListadoVistas = ({ setOpenModalForm }) => {
  const dispatch = Redux.useDispatch();
  const { notify } = useNotification();

  const vistasStore = Redux.useSelector((state) => state.vistas);

  const [loadingDelete, setLoadingDelete] = React.useState(false);
  const [openModalDelete, setOpenModalDelete] = React.useState(false);

  React.useEffect(() => {
    async function fetchData() {
      if (vistasStore.all && vistasStore.all.length === 0) {
        await allVistasAction(dispatch, null);
      }
    }
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const _handleEditClick = async (id) => {
    const data = vistasStore.all.find((el) => el.id === id);
    await setActivoVistasAction(dispatch, data);
    setOpenModalForm(true);
  };

  async function _onDeleteHandler() {
    setLoadingDelete(true);
    await deleteVistasAction(
      { dispatch, notify },
      vistasStore.activo.id,
      vistasStore.params,
    );
    setOpenModalDelete(false);
    setLoadingDelete(false);
  }

  const columns = [
    {
      name: CONST.ID,
      options: {
        // display: loginStore.isRoot ? false : 'excluded',
        filter: false,
      },
    },
    {
      name: CONST.icon.name,
      label: CONST.icon.label,
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value, tableMeta, updateValue) => {
          return <Avatar size={30} src={`./static/images/png/${value}.png`} />;
        },
      },
    },
    {
      name: CONST.nombre.name,
      label: CONST.nombre.label,
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <NameComponent
              onClick={() => _handleEditClick(tableMeta.rowData[0])}
            >
              {value}
            </NameComponent>
          );
        },
      },
    },
    {
      name: CONST.modulo.name,
      label: CONST.modulo.label,
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <NameComponent
              onClick={() => _handleEditClick(tableMeta.rowData[0])}
            >
              {value.nombre}
            </NameComponent>
          );
        },
      },
    },
    {
      name: CONST.route.name,
      label: CONST.route.label,
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                overflow: 'hidden',
                width: value.length > 100 ? '15vw' : '10vw',
              }}
            >
              {value}
            </Box>
          );
        },
      },
    },
    {
      name: CONST.alias.name,
      label: CONST.alias.label,
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                overflow: 'hidden',
                width: '12vw',
              }}
            >
              {value}
            </Box>
          );
        },
      },
    },
    // {
    //   name: CONST.imagen.name,
    //   label: CONST.imagen.label,
    //   options: {
    //     filter: true,
    //     sort: true,
    //   },
    // },

    {
      name: CONST.estatus.name,
      label: CONST.estatus.label,
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <Tooltip
              describeChild
              title="Estatus del registro"
              placement="left"
            >
              <Chip
                label={value.nombre}
                size="small"
                color={value.id === 1 ? 'success' : 'error'}
              />
            </Tooltip>
          );
        },
      },
    },
    {
      name: CONST.actions.name,
      label: CONST.actions.label,
      options: {
        filter: false,
        sort: false,
        empty: true,
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <Stack direction="row">
              <ActionsListWidget
                id={tableMeta.rowData[0]}
                onEdit={() => _handleEditClick(tableMeta.rowData[0])}
                onDelete={() => {
                  const data = vistasStore.all.find(
                    (el) => el.id === tableMeta.rowData[0],
                  );
                  setActivoVistasAction(dispatch, data);
                  setOpenModalDelete(true);
                }}
              />
            </Stack>
          );
        },
      },
    },
  ];

  const options = {
    filterType: 'dropdown',
    setTableProps: () => {
      return {
        padding: 'none',
        size: 'small',
      };
    },
    rowsPerPage: 25,
    rowsPerPageOptions: [25, 50, 100],
    print: false,
    download: false,
    textLabels,
    selectableRowsHideCheckboxes: true,
    expandableRows: true,
    renderExpandableRow: (rowData, rowMeta) => {
      return <Grid container></Grid>;
    },
  };

  const isEntidades = vistasStore.activo?.totalEntidades > 0;

  return (
    <Grid container>
      <Grid item md={12}>
        <LoadingWidget isLoading={vistasStore.loadingAll || loadingDelete} />
        <MUIDataTable
          title={'Listado'}
          data={vistasStore.all}
          columns={columns}
          options={options}
        />
      </Grid>
      {vistasStore.activo && (
        <DeleteModalComponent
          open={openModalDelete}
          onClose={() => setOpenModalDelete(!openModalDelete)}
          onDelete={_onDeleteHandler}
          isText={!isEntidades}
          isConfirmBottom={!isEntidades}
        >
          {isEntidades ? (
            <Typography variant="body1">
              No puedes eliminar esta carrera porque tiene entidades relacionada
            </Typography>
          ) : (
            <Typography variant="h6">{vistasStore.activo.nombre}</Typography>
          )}
        </DeleteModalComponent>
      )}
    </Grid>
  );
};

export default ListadoVistas;
